import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"

const useStyles = makeStyles((theme) => ({
  dot: {
    height: 10,
    width: 10,
    backgroundColor: (props) =>
      (props.status === "active" && "#8BC34A") ||
      (props.status === "upcoming" && "blue") ||
      "#bbb",
    borderRadius: "50%",
    marginRight: theme.spacing(0.5),
  },
}))

const Status = ({ status = "expired" }) => {
  const classes = useStyles({ status })
  return (
    <Grid container alignItems="center">
      <div className={classes.dot} />
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </Grid>
  )
}

export default Status
